import { useState } from 'react';
import './slidingPaneContent.scss';
import { LinkTo } from '../Footer';
import questions from '../../../../assets/icons/question-mark-qa.svg';
import helpdesk from '../../../../assets/icons/headphones.svg';
import globe from '../../../../assets/icons/globe.svg';
import facebookLogo from '../../../../assets/images/facebook.png';
import playVideoIcon from '../../../../assets/images/play_video.png';
import backIcon from '../../../../assets/icons/right-back-arrow.svg';
import checkMark from '../../../../assets/icons/check-mark.svg';

declare function Translate(key: string): string;
declare function LoadTranslation(lang: string);
declare var _siteSettings: any;
declare var _curLang: any;

export const SlidingPaneContent = ({ slidingPaneCallback }) => {
  
  const [isLanguagesSelection, setisLanguagesSelection] = useState(false);
  const [selectedLang, setSelectedLang] = useState(_curLang);

  const changeLang = async (index) => {
    setSelectedLang(_siteSettings.langs[index].toString());
    await LoadTranslation(_siteSettings.langs[index].toString());
    slidingPaneCallback(false);
  };

  return (
    <div className='sliding-content'>
      {isLanguagesSelection ? (
        <div className='languages-select--heading'>
          <span onClick={() => setisLanguagesSelection(false)}>
            <img src={backIcon} className='back-btn' />
          </span>
          <span className='languages-select-back-title'>
            {Translate('N_General_main_language_select')}
          </span>
        </div>
      ) : (
        <div
          className='closeIcon'
          onClick={() => {            
            slidingPaneCallback(false);
          }}
        >
          &#10006;
        </div>
      )}
      {isLanguagesSelection ? (
        <div className='languages-select'>
          <div className='menu'>
            {_siteSettings.langs.map((langName, index) => {
              return (
                <div
                  className={
                    langName === selectedLang
                      ? 'lang-item'.concat(' selectedLang') 
                      : 'lang-item'
                  }
                  key={index}
                  id={langName}
                  onClick={() => changeLang(index)}
                >
                  {Translate(`N_General_main_language_select_${langName}`)}
                  <img
                    src={checkMark}
                    alt='Selected language'
                    style={
                      langName === selectedLang
                        ? { display: 'inline-block' }
                        : { display: 'none' }
                    }
                  />
                </div>
              );
            })}
          </div>
        </div>
      ) : (
        <div className='main-content'>
          <div className='menu'>
            <div className='item'>
              <img src={questions}  />
              <a href={_siteSettings.faqLink}>
                {Translate('N_General_TEXT_FOOTER_FAQ')}{' '}
              </a>
            </div>
            <div className='item'>
              <img src={helpdesk}  />
              <a href={_siteSettings.callCenterLink}>
                {Translate('N_General_TEXT_HELPDESK')}{' '}
              </a>
            </div>
            <hr />
            {/* <div className='language'>
              <img src={globe}  />
              <span className='link'>
                <span>
                  {Translate(`N_General_main_language_select_${selectedLang}`)}
                </span>
              </span>
              <a
                className='link'
                onClick={() => setisLanguagesSelection(true)}
                style={{ fontWeight: 600 }}
              >
                {Translate('N_General_main_language_select')}
              </a>
            </div> */}
          </div>
          <div className='support'>
            <span>{Translate('N_General_TEXT_HELPDESK')}</span>
            <a className='link' href='tel:1299'>
              1299
            </a>
          </div>
          <div className='footer'>
            <a className='item' href={_siteSettings.termsOfUseLink}>
              {Translate('N_General_TEXT_FOOTER_TOS')}{' '}
            </a>
            <span className='pipe'>&nbsp;|&nbsp;</span>
            <a className='item' href={_siteSettings.accessibilityLink}>
              {Translate('N_General_Accessibility_declaration')}{' '}
            </a>
          </div>
          <div className='social'>
            <div
              onKeyDown={(e) => LinkTo(e, _siteSettings.movieLink)}
              onClick={() => window.open(_siteSettings.movieLink)}
              tabIndex={0}
              role='link'
            >
              <img src={playVideoIcon}  />
            </div>
            <div
              onKeyDown={(e) => LinkTo(e, _siteSettings.facebookLink)}
              onClick={() => window.open(_siteSettings.facebookLink)}
              tabIndex={0}
              role='link'
            >
              <img src={facebookLogo}  />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
